// extracted by mini-css-extract-plugin
export default {"root":"ScheduleResumeButton_root__oAiLI","button":"ScheduleResumeButton_button__v-ujr"};